import { Link } from 'react-router-dom';
import blogPosts from '../content/blogPosts';
import './blog.css';

const formatDate = (dateString) => {
    const d = new Date(dateString);
    return d.toLocaleDateString('en-US', {
        month: 'long',
        day: 'numeric',
        year: 'numeric'
    });
};

const BlogPage = () => {
    return (
        <div className="blog-shell">
            <section className="blog-hero">
                <p className="blog-kicker">Resources</p>
                <h1>Insights for Better Property Decisions</h1>
                <p>Practical playbooks on pricing, operations, and reporting for rental operators and owners.</p>
            </section>

            <section className="blog-list">
                {blogPosts.map((post) => (
                    <article key={post.slug} className="blog-card">
                        <div className="blog-card-meta">
                            <span>{post.category}</span>
                            <span>{formatDate(post.date)}</span>
                            <span>{post.readTime}</span>
                        </div>
                        <h2>{post.title}</h2>
                        <p>{post.excerpt}</p>
                        <Link to={`/blog/${post.slug}`} className="blog-read-link">Read article</Link>
                    </article>
                ))}
            </section>
        </div>
    );
};

export default BlogPage;
